module.exports = __webpack_public_path__ + "static/img/Lachie_Neale_desktop.4e67c0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lachie_Neale_desktop.jpg
// module id = O8Lv
// module chunks = 0